import { Component, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { GridComponent, GridDataResult, RowClassArgs } from '@progress/kendo-angular-grid';
import { GridBaseComponent } from '../../../../../components/common/grid-base/grid-base';
import { PolluxGridConfig } from '../../../../../components/common/pollux-grid-config/pollux-grid-config';
import { WorkspaceBase } from '../../../../../components/common/workspace-base/workspace-base';
import { ComparablesPropertiesWorkspaceComponent } from '../../workspaces/comparables-properties-workspace/comparables-properties-workspace.component';
import { propertiesGridColumns } from './comparables-properties-grid-config';

/**
 * Properties grid (comps)
 */
@Component({
  selector: 'comparables-properties-grid',
  templateUrl: './comparables-properties-grid.component.html',
  styleUrls: ['./comparables-properties-grid.component.scss']
})
export class ComparablesPropertiesGridComponent extends GridBaseComponent implements OnInit {
  /**
   * A reference to the Kendo grid component
   */
  @ViewChild(GridComponent) kendoGrid: GridComponent;

  /**
   * A reference to the workspace
   */
  public get workspaceReference(): WorkspaceBase {
    return this.workspace;
  }

  /**
   * Gets a list of columns
   * @returns
   */
  public getColumns(): PolluxGridConfig[] {
    return propertiesGridColumns;
  }

  /**
   * The workspace
   */
  @Input() workspace: ComparablesPropertiesWorkspaceComponent;

  /**
   * Constructor
   * @param injector The Angular injector
   */
  constructor(protected injector: Injector) {
    super(injector, 'comparablesProperty', true);
  }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    this.init();
  }

  /**
   * Handle a row selection / deselection event
   * @param _event The event. Can be null!
   * @param item The item. If an item was deselected, it's null
   */
  protected handleRowSelection(_event: any, item: any): void {
    if (item) {
      this.workspace.onElementSelected(item);
      //inform infobar if required
      this.eventBus.broadcastEvent('comparables-infobar-item-changed', {
        mode: 'property',
        item: item,
        itemIdentityProperty: 'Oid'
      });
    }
    else {
      this.workspace.onElementDeselected();
    }
  }

  /**
   * Handle a doubleclick event
   * @param _event The event. Can be null!
   * @param item The item
   */
  protected handleDoubleClick(_event: any, item: any): void {
    this.workspace.showForm(item.Oid);
  }

  /**
   * Gets the url for loading a paged list
   * @returns The url for loading a paged list
   */
  protected getPagedListEndpoint(): string {
    return this.appServiceHelper.getServiceEndpoint('pollux.comparables.api', `Properties/list/paged`);
  }

  /**
   * Reset the filters and show all items
   */
  public showAll(): void {
    super.showAll(null);
    this.workspace.onShowAll();
  }

  /**
   * Data loading callback
   * @param data The loaded data
   */
  protected onDataLoaded(data: GridDataResult) {
    this.workspace.setCounterValue('comparablesProperty', data.total);
  }

  /**
   * Callback to apply CSS classes to grid row
   */
  public rowClassCallback = (context: RowClassArgs) => {
    const rowClasses: any = {
      projectstdRow: true,
      recordStatusInactive: context.dataItem.RecordStatusId === 2
    };

    return rowClasses;
  };
}
